import Grid from '@mui/material/Grid';

import { ExternalReferences } from './ExternalReferences';

interface Props {
  readonly id: string;
}

// The references an external actor gives the entity.
export const ActorReferencesFormStep = (_: Readonly<Props>) => (
  <Grid container spacing={2} sx={{ alignContent: 'flex-start' }}>
    <Grid size={12} sx={{ pt: 1, pb: 1 }}>
      <ExternalReferences />
    </Grid>
  </Grid>
);
